import { SET_COLUMN_SELECTOR, SET_ORIGINAL_COLUMN_SELECTOR } from "./ColumnSelectorAction";

/**
 * 
 * @param {*} state 
 * @param {*} action 
 * @returns 
 * 
 * Reducer for Column Selector content
 */
export default function ColumnSelectorReducer(
  state = {
    columnSelectorPlugins: [],
    originalColumnSelectors: new Map()
  },
  action
) {
  switch (action.type) {
    case SET_COLUMN_SELECTOR:
      return {
        ...state,
        columnSelectorPlugins: action.payload ? action.payload : []
      };
      case SET_ORIGINAL_COLUMN_SELECTOR:
        return {
          ...state,
          originalColumnSelectors: action.payload ? action.payload : new Map()
        };
    default:
      return state;
  }
}
